import { BrowserRouter as Router } from 'react-router-dom';

import { MessageHandler } from '@/components/MessageHandler/MessageHandler';
import Routes from '@/components/Routes';
import { Store } from '@/components/Store';

/**
 * App component
 * @returns {ReactElement}
 */
const App = () => {
  return (
    <Store>
      <Router>
        <MessageHandler>
          <Routes />
        </MessageHandler>
      </Router>
    </Store>
  );
};

export default App;
